/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientProcedureConsumable from './patient-procedure-consumable';
import PatientProcedureConsumableDetail from './patient-procedure-consumable-detail';
import PatientProcedureConsumableUpdate from './patient-procedure-consumable-update';
import PatientProcedureConsumableDeleteDialog from './patient-procedure-consumable-delete-dialog';

const PatientProcedureConsumableRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientProcedureConsumable />} />
    <Route path="new" element={<PatientProcedureConsumableUpdate />} />
    <Route path=":id">
      <Route index element={<PatientProcedureConsumableDetail />} />
      <Route path="edit" element={<PatientProcedureConsumableUpdate />} />
      <Route path="delete" element={<PatientProcedureConsumableDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientProcedureConsumableRoutes;
